import type { Channel } from "phoenix";

export const setupChannelListeners = (
  channel: Channel | undefined,
  events: { event: string; handler: (data: unknown) => void }[]
) => {
  if (!channel) return

  events.forEach(({ event, handler }) => {
    channel.on(event, handler)
  })
  return () => {
    events.forEach(({ event }) => {
      channel.off(event)
    })
  }
}